// Get Regularusers Group
export const GET_REGULARUSERS_GROUP_REQUEST = 'GET_REGULARUSERS_GROUP_REQUEST';
export const GET_REGULARUSERS_GROUP_DONE = 'GET_REGULARUSERS_GROUP_DONE';
export const GET_REGULARUSERS_GROUP_FAILED = 'GET_REGULARUSERS_GROUP_FAILED';
